(() => {
  const init = (scope = document) => {
    const header = scope.querySelector('.fr-header--layered');
    if (!header || header.dataset.layeredReady) return;
    header.dataset.layeredReady = 'true';
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    const section = header.closest('.shopify-section') || document;
    const menu = section.querySelector('.fr-mobile-menu--layered');
    const backdrop = section.querySelector('[data-header-menu-backdrop]');
    const openers = [...header.querySelectorAll('[data-menu-open]')];
    const desktop = header.querySelector('[data-layered-menu="desktop"]');
    const media = window.matchMedia('(min-width: 1101px)');
    let returnFocus = null;
    let wasOpen = false;
    const closeGroups = (root, except) => root?.querySelectorAll('[data-nav-group][open]').forEach(group => { if (group !== except) group.open = false; });
    const syncMenu = () => {
      if (!menu) return;
      const open = menu.classList.contains('is-open');
      menu.inert = !open;
      menu.setAttribute('aria-hidden', String(!open));
      openers.forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (backdrop) backdrop.hidden = !open;
      document.body.classList.toggle('fr-header-menu-open', open);
      if (open && !wasOpen) {
        returnFocus = document.activeElement;
        menu.querySelector('[data-menu-close]')?.focus();
      } else if (!open && wasOpen) {
        closeGroups(menu);
        if (returnFocus?.isConnected) returnFocus.focus();
      }
      wasOpen = open;
    };
    const setMenu = open => { menu?.classList.toggle('is-open', open); syncMenu(); };
    openers.forEach(button => button.addEventListener('click', () => setMenu(true)));
    menu?.querySelectorAll('[data-menu-close]').forEach(button => button.addEventListener('click', () => setMenu(false)));
    backdrop?.addEventListener('click', () => setMenu(false));
    const observer = new MutationObserver(syncMenu);
    if (menu) observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    section.querySelectorAll('[data-layered-menu]').forEach(nav => nav.addEventListener('toggle', event => {
      const group = event.target;
      if (!group.matches('[data-nav-group]')) return;
      group.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(group.open));
      if (group.open) closeGroups(nav, group);
    }, true));
    desktop?.querySelectorAll('[data-nav-group]').forEach(group => {
      let leaveTimer;
      group.addEventListener('mouseenter', () => {
        if (!media.matches || !window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(leaveTimer);
        closeGroups(desktop, group);
        group.open = true;
      });
      group.addEventListener('mouseleave', () => {
        leaveTimer = setTimeout(() => { if (!group.contains(document.activeElement)) group.open = false; }, 140);
      });
      group.addEventListener('focusout', () => setTimeout(() => { if (!group.contains(document.activeElement)) group.open = false; }, 0));
    });
    document.addEventListener('pointerdown', event => { if (!desktop?.contains(event.target)) closeGroups(desktop); }, listenerOptions);
    document.addEventListener('keydown', event => {
      if (menu?.classList.contains('is-open')) {
        if (event.key === 'Escape') { event.preventDefault(); setMenu(false); return; }
        if (event.key !== 'Tab') return;
        const focusable = [...menu.querySelectorAll('a[href],button,summary,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.disabled && !el.closest('[inert]'));
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      } else if (event.key === 'Escape') {
        const group = desktop?.querySelector('[data-nav-group][open]');
        if (group) { event.preventDefault(); group.open = false; group.querySelector('summary')?.focus(); }
      }
    }, listenerOptions);
    media.addEventListener('change', () => { setMenu(false); closeGroups(desktop); }, listenerOptions);
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(header)) return;
      setMenu(false);
      observer.disconnect();
      controller.abort();
    }, listenerOptions);
    syncMenu();
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
